export default __webpack_public_path__ + "static/media/intern-font.62e36363.woff";